import React from "react";
import { ReportList } from "./ReportList";

export function ReportListContainer() {
  return <ReportList />;
}

